module.exports = __webpack_public_path__ + "img/UsgsTurquoiseSymbol.2513f421.svg";